import merge from 'deepmerge';

export const extend = (...components) => {
  const models = components.map((component) => {
    if (component.dataModel) {
      return component.dataModel;
    }
    return component;
  });

  return models.reduce((acc, cur) => {
    return merge(acc, cur);
  }, {});
};
